export function createAppTitle(appTitleBase: string, featureName: string): string {
  return `${featureName} [${appTitleBase}]`;
}

export function getFeatureNameFromAppTitle(appTitle: string): string {
  return appTitle.split(' [')[0]?.trim() || '';
}
